var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSicns(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 66.888,
    height: 17.328,
    viewBox: "0 0 66.888 17.328",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2207",
    "data-name": "Trazado 2207",
    d: "M8.856-10.272c-2.664-.624-3.384-.96-3.384-2.016,0-.744.6-1.512,2.4-1.512a5.123,5.123,0,0,1,3.816,1.728l2.424-2.352a8.029,8.029,0,0,0-6.12-2.64c-3.312,0-6,1.872-6,4.92,0,3.312,2.16,4.3,5.256,5.016,3.168.72,3.744,1.2,3.744,2.28,0,1.272-.936,1.824-2.928,1.824a5.443,5.443,0,0,1-4.3-1.92L1.344-2.784A7.789,7.789,0,0,0,7.872.264c4.584,0,6.6-2.16,6.6-5.352C14.472-8.736,11.52-9.648,8.856-10.272ZM21.624-16.8h-3.36V0h3.36Zm11.136-.264c-4.392,0-7.464,3.552-7.464,8.664C25.3-3.1,28.248.264,32.64.264a6.418,6.418,0,0,0,6.216-3.792l-2.832-1.68c-.888,1.488-1.776,2.136-3.288,2.136-2.52,0-3.984-2.3-3.984-5.328,0-3.12,1.44-5.328,3.96-5.328A3.191,3.191,0,0,1,35.784-11.9l3.12-1.44A6.337,6.337,0,0,0,32.76-17.064Zm21.12.264H52.824V-1.992L43.488-16.8h-1.08V0h1.08V-14.9L52.9,0h.984Zm9.456,7.608c-3.456-1.272-4.224-2.088-4.224-3.792,0-1.608,1.2-3.072,3.84-3.072A6.408,6.408,0,0,1,67.2-14.592l.72-.864a7.574,7.574,0,0,0-4.9-1.608c-3.144,0-5.016,1.752-5.016,4.152,0,2.3,1.1,3.36,4.728,4.7,3.336,1.224,4.392,2.184,4.392,4.032,0,2.256-1.8,3.432-4.08,3.432a6.989,6.989,0,0,1-4.7-1.824l-.744.816A8.034,8.034,0,0,0,63,.264c3.048,0,5.232-1.728,5.232-4.488C68.232-6.648,67.056-7.824,63.336-9.192Z",
    transform: "translate(-1.344 17.064)",
    fill: "#212130"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSicns);
export default __webpack_public_path__ + "static/media/sicns.dab510578da455e9e201e792ad9bbb25.svg";
export { ForwardRef as ReactComponent };